import { render, staticRenderFns } from "./SummaryScreen.vue?vue&type=template&id=bdb7c4aa&scoped=true"
import script from "./SummaryScreen.vue?vue&type=script&lang=js"
export * from "./SummaryScreen.vue?vue&type=script&lang=js"
import style0 from "./SummaryScreen.vue?vue&type=style&index=0&id=bdb7c4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb7c4aa",
  null
  
)

export default component.exports